module.exports = __webpack_public_path__ + "static/img/0b773b95-677b-414a-a690-d88c5cb52568.f6fa4fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/0b773b95-677b-414a-a690-d88c5cb52568.png
// module id = z+DW
// module chunks = 1